import './LoadingState.css';
export var dataTableHeaderHeight = 'var(--_14flfjk0-3-5-0)';
export var loadingState = '_14flfjk1-3-5-0';